// Section for import npm components -----------------------------------------------------------------------------------
import React, { createContext, useState, useContext } from 'react';
// Section for type definition -----------------------------------------------------------------------------------------
import { RentMarketPriceHistoryContextType } from '@/types/components/MansionDetail/RentMarketPriceHistoryPropsData';

const initRentMarketPriceHistory: RentMarketPriceHistoryContextType = {
  RentMarketPriceHistoryData: false,
  averageSquareMeter: 0,
  selectedSquareMeter: 0,
  rangeOfYear: 1,
};

export const RentMarketPriceHistoryContext: React.Context<RentMarketPriceHistoryContextType> =
  createContext<RentMarketPriceHistoryContextType>(initRentMarketPriceHistory);
export const UpdateRentMarketPriceHistory: React.Context<any> = createContext(initRentMarketPriceHistory);
// export const SelectedCitiesConsumer = SelectedCitiesContext.Consumer;
export const useRentMarketPriceHistory = () => useContext(RentMarketPriceHistoryContext);
export const useUpdateRentMarketPriceHistory = () => useContext(UpdateRentMarketPriceHistory);
function RentMarketPriceHistoryProvider(props: any): React.JSX.Element {
  const { children, mansionRentMarketPriceHistory } = props;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [stateRentMarketPriceHistory, setRentMarketPriceHistory] = useState(mansionRentMarketPriceHistory);
  // valueにグローバルに扱う値を設定

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <RentMarketPriceHistoryContext.Provider value={mansionRentMarketPriceHistory}>
      <UpdateRentMarketPriceHistory.Provider value={setRentMarketPriceHistory}>
        {children}
      </UpdateRentMarketPriceHistory.Provider>
    </RentMarketPriceHistoryContext.Provider>
  );
}

export default RentMarketPriceHistoryProvider;
